<script setup lang="ts">
const highlightedItems = [
  {
    title: 'Tanpa Kontrak',
    icon: 'material-symbols:gavel'
  },
  {
    title: 'Tanpa biaya bulanan',
    icon: 'ka-icon:rp'
  },
  {
    title: 'Bisa langsung jalan',
    icon: 'material-symbols:local-shipping-outline'
  }
]
</script>
<template>
  <CtaSection
    title="Saatnya Pelanggan Kamu Balik Beli Lagi!"
    subtitle="ROMS KiriminAja"
    description="Dengan ROMS KiriminAja, repeat order jalan otomatis, kamu bisa fokus ke pengembangan bisnis."
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
  >
    <template #hero>
      <NuxtImg
        alt="Integrasi API Kurir & Ekspedisi"
        src="/images/cod-cair-cepat-banner-3.webp"
        class="xl:block hidden"
      />
    </template>
    <template #action>
      <div class="flex items-center gap-2 lg:gap-4 py-2">
        <UiButton
          :to="
            $utm.utmUrl('/register', {
              redirectTo: '/crm/config?meta_setup=1'
            })
          "
          label="Coba ROMS"
        />
        <UiButton
          :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
          label="Hubungi Kami"
          variant="primaryOutline"
        />
      </div>
      <div class="flex flex-col lg:flex-row lg:items-center gap-4 lg:flex-wrap">
        <UiCardFeature
          v-for="(item, key) in highlightedItems"
          :key="key"
          class="bg-surface-container"
          wrapper-class="bg-surface-container flex-row items-center p-3"
          title-class="text-sm lg:text-sm"
          icon-wrapper-class="bg-background"
          :icon="item.icon"
          icon-size="24px"
          :title="item.title"
        />
      </div>
    </template>
  </CtaSection>
</template>
